import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Menu View Config"})
export default class MenuViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Vertical Orientation"})
	public vertical: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Collapsible"})
	public collapsible?: boolean;

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor: string;

	@Input({type: InputType.BACKGROUND_IMAGE, title: "Background Image"})
	public backgroundImage: string;

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding: string = "0px 0px 0px 0px";

}



// WEBPACK FOOTER //
// ./src/common/views/menu/MenuViewConfig.ts